import { boolean, InferType, object, ref, string } from 'yup';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

export const useVehicleFormSchema = () => {
	const { t } = useTranslation();
	return object({
		description: string()
			.max(30, t('user_form_description_too_long_error'))
			.required(t('description_form_field_error')),
		licensePlateNumber: string()
			.min(1, t('user_form_license_plate_invalid_error'))
			.required(t('license_plate_form_field_error')),
		confirmLicensePlateNumber: string()
			.oneOf<string>(
				[ref('licensePlateNumber'), ''],
				t('user_form_confirm_license_plate_number_mismatch_error'),
			)
			.required(t('license_plate_form_field_error')),
		favorite: boolean().oneOf([true, false]).required(),
	}).required();
};

export type VehicleFormData = InferType<
	ReturnType<typeof useVehicleFormSchema>
>;
